import React from "react";
import { cn } from "../../lib/utils";

export function Alert({ children, variant = "default" }) {
  const baseClasses = "p-4 mb-4 rounded-md";
  const variantClasses = {
    default: "bg-blue-100 text-blue-700",
    destructive: "bg-red-100 text-red-700",
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]}`}>
      {children}
    </div>
  );
}

export function AlertDescription({ children }) {
  return <p>{children}</p>;
}

export function AlertTitle({ children, className, ...props }) {
  return (
    <h5 className={cn("font-medium text-sm mb-1", className)} {...props}>
      {children}
    </h5>
  );
}
